import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useCallback, useEffect } from "react";
import { useRegisterTeam } from "../../../api/hooks";
import { classNames } from "../../../utils";
import { useSearchParams } from "react-router-dom";

const PaymentStatusPage = () => {
  const [searchParams] = useSearchParams();
  const teamId = searchParams.get("team");
  const code = searchParams.get("code");
  const orderId = searchParams.get("orderId");
  const checkoutIntentId = searchParams.get("checkoutIntentId");

  const isSuccessful = code === "succeeded";

  const registerTeam = useRegisterTeam();

  const updateTeam = useCallback(async () => {
    console.log("updateTeam", teamId, code, orderId, checkoutIntentId);
    if (teamId && code === "succeeded" && orderId && checkoutIntentId) {
      await registerTeam.mutateAsync({
        recordId: teamId,
        order_id: orderId,
        checkout_intent_id: checkoutIntentId,
      });
    }
  }, [teamId, code, orderId, checkoutIntentId, registerTeam]);

  const onGoBack = () => {
    window.parent.location.href = `/register?team=${teamId}`;
  };

  useEffect(() => {
    updateTeam();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const timeout = setTimeout(() => {
      window.parent.location.href = `/register?team=${teamId}`;
    }, 5000);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95">
        <div>
          <div
            className={classNames(
              "mx-auto flex w-12 h-12 items-center justify-center rounded-full",
              isSuccessful ? "bg-green-100" : "bg-red-100"
            )}
          >
            {isSuccessful ? (
              <CheckIcon
                aria-hidden="true"
                className="w-6 h-6 text-green-600"
              />
            ) : (
              <XMarkIcon aria-hidden="true" className="w-6 h-6 text-red-600" />
            )}
          </div>
          <div className="mt-3 text-center sm:mt-5">
            <h3 className="text-base font-semibold text-gray-900">
              {isSuccessful ? "Paiement réussi" : "Paiement échoué"}
            </h3>
            <div className="mt-2">
              <p className="text-sm text-gray-500">
                {isSuccessful
                  ? "Votre paiement a été effectué avec succès."
                  : "Votre paiement a échoué."}
              </p>
              <p className="text-sm text-gray-500">
                Vous allez être <strong>automatiquement redirigé</strong> vers
                la page d'inscription dans quelques secondes.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-5 sm:mt-6">
          <button
            type="button"
            onClick={onGoBack}
            className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Retour à votre inscription
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentStatusPage;
